import { type FC } from 'react';
import { Button } from '@ui/button';

interface ShowAllButtonProps {
  onClick: () => void;
}

export const ShowAllButton: FC<ShowAllButtonProps> = ({ onClick }) => {
  return (
    <div className="p-3">
      <Button
        variant="ghost"
        className="w-full cursor-pointer border-0 bg-surface-card-muted hover:bg-action-secondary-hover"
        onClick={onClick}
      >
        Показать всё расписание
      </Button>
    </div>
  );
};
